var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransactionWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 2H12.0002C13.4668 2 14.6668 3.2 14.6668 4.66667C14.6668 5.8 14.0002 6.73333 13.0002 7.13333V4.66667C13.0002 4.4 12.8668 4.13333 12.7335 3.93333C12.6002 3.73333 12.2668 3.66667 12.0002 3.66667H4.00016C3.7335 3.66667 3.46683 3.8 3.26683 3.93333C3.06683 4.06667 3.00016 4.4 3.00016 4.66667V7.13333C2.00016 6.73333 1.3335 5.8 1.3335 4.66667C1.3335 3.2 2.5335 2 4.00016 2Z",
    fill: "#DB7802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.66663V12.6666C12 13.4 11.4 14 10.6667 14H5.33333C4.6 14 4 13.4 4 12.6666V4.66663H12ZM7 9.66663L7.46667 10.1333V7.33329C7.46667 7.06663 7.66667 6.79996 8 6.79996C8.33333 6.79996 8.53333 6.99996 8.53333 7.33329V10.1333L9 9.66663C9.2 9.46663 9.53333 9.46663 9.73333 9.66663C9.93333 9.86663 9.93333 10.2 9.73333 10.4L8.86667 11.2666C8.4 11.7333 7.66667 11.7333 7.2 11.2666L6.33333 10.4C6.13333 10.2 6.13333 9.86663 6.33333 9.66663C6.53333 9.46663 6.8 9.46663 7 9.66663Z",
    fill: "#DB7802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionWithdraw);
export default __webpack_public_path__ + "static/media/icon_transaction_withdraw.2ed4006f8e8349270df834af99748def.svg";
export { ForwardRef as ReactComponent };